<template>
    <div>
       <div style="background: red; color: #fff; text-align: center; padding: 5px" v-if="currentUser.user.type === 'master'">Super ADM</div>
      <el-menu
        :default-active="activeIndex"
        class="aside-menu-dashboard"
        background-color="rgba(255, 255, 255, 0)"
        @select="handleSelect"
        router
      >
        <el-menu-item @click="openMenu" index="1" :route="{name: 'dashboard'}">
          <strong><i class="el-icon-odometer"></i>
         <span>Dashboard</span></strong></el-menu-item>

        <el-submenu index="3">

          <template slot="title">
            <i class="el-icon-s-custom"></i>
            <span class="font-weight-bold">Painel do Anfitrião</span>
          </template>

          <el-menu-item-group>
            <el-menu-item
              index="3-1" :route="{name: 'my-bikes',  params: { page: 'minhas-bicicletas' } }" @click="openMenu">
              <i class="el-icon-bicycle"></i> Minhas Bicicletas</el-menu-item>

            <el-menu-item
              @click="openMenu"
              :disabled="!this.$store.state.user.data.bikes || !this.$store.state.user.data.bikes.length"
              index="3-2" :route="{name: 'my-bikes',  params: { page: 'pedidos' } }">
              <i class="el-icon-document-copy"></i>Reservas</el-menu-item>

             <el-menu-item
                :disabled="!this.$store.state.user.data.bikes || !this.$store.state.user.data.bikes.length"
                @click="() => this.$router.push(`/anunciante/${this.$store.state.user.data._id}`)"
                >
                <i class="el-icon-postcard"></i>Minha página pública</el-menu-item>

<!--            <el-submenu :disabled="!this.$store.state.user.data.digitalAccount" index="3-3">
              <template slot="title"><i class="el-icon-wallet"></i> Financeiro</template>

               <el-menu-item
                  @click="openMenu"
                  :disabled="!registerStatus"
                  index="3-3-1" :route="{name: 'my-bikes',  params: { page: 'extrato' } }"> <i class="el-icon-tickets"></i>Extrato</el-menu-item>


            </el-submenu>-->


          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="4">

          <template slot="title">
            <i class="el-icon-user"></i>
            <span class="font-weight-bold">Painel do Ciclista</span>
          </template>

          <el-menu-item-group>

            <el-menu-item
              @click="openMenu"
              index="4-1" :route="{name: 'my-reservations'}">
              <i class="el-icon-date"></i> Minhas Reservas</el-menu-item>

<!--             <el-menu-item
                @click="openMenu"
                index="4-2" :route="{name: 'my-extract'}">
                <i class="el-icon-tickets"></i> Extrato</el-menu-item>-->

            <el-menu-item
               v-if="0"
              @click="openMenu"
              index="4-3" :route="{name: 'cards'}">
              <i class="el-icon-bank-card"></i> Meus Cartões</el-menu-item>

          </el-menu-item-group>
        </el-submenu>

         <el-menu-item @click="openMenu" index="5" :route="{name: 'chat'}">
            <strong><i class="el-icon-chat-line-round"></i>
               Chat</strong></el-menu-item>

         <el-menu-item @click="openMenu" index="6" :route="{name: 'comments'}">
            <strong><i class="el-icon-star-off"></i>
               Avaliações</strong></el-menu-item>


        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-set-up"></i>
            <span class="font-weight-bold">Minha Conta</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              @click="openMenu"
              index="2-1" :route="{name: 'profile'}">
              <i class="el-icon-notebook-2"></i>
              Meus Dados</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item
              @click="openMenu"
              index="2-3" :route="{name: 'verificacoes'}">
              <i class="el-icon-medal"></i>
              Verificações</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item
              @click="openMenu"
              index="2-2"
              :route="{name: 'security'}">
              <i class="el-icon-lock"></i>
              Segurança</el-menu-item>
          </el-menu-item-group>

          <el-menu-item-group>
            <el-button
              title="Deslogar-se"
              type="text"
              style="padding: 15px 38px; color: #303133; width: 100%; text-align: left;"
              @click="logOut"
              index="2-4">
              <i style="color: #909399" class="el-icon-switch-button"></i>
              Sair</el-button>
          </el-menu-item-group>

        </el-submenu>


      </el-menu>


    </div>
</template>

<script>
 export default {
    name: 'DashUserNav',

    data() {
        return {
          activeIndex: '1',
          openMenuMobile: false,
          router: ''
        }
    },
    mounted() {

    },
    methods: {

      handleSelect(key) {
        this.activeIndex = key
       // console.log('handleSelect', key, keyPath);
      },

     /* handleOpen(key, keyPath) {
        //console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
       // console.log(key, keyPath);
      }*/
      openMenu() {
        var element = document.getElementById("app");
        element.classList.toggle("openMenuMobile");
      },

      logOut() {
        this.$loading({
          lock: true,
          text: 'Saindo...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        setTimeout(() => {
          this.$store.dispatch('user/clear')
          if (localStorage.getItem('user')) {
            try {
              localStorage.removeItem('user');
              this.$router.go('/login');
            } catch(e) {
              this.$router.go('/login');
            }
          }
          // loading.close();

        }, 1000);

      },
    },
    computed: {
      newOrdersQuery() {
          return this.$store.state.order.newOrders;
      },
      totalBikes() {
        return this.$store.state.bike.totalBikes;
      },
      currentRouteName() {
        return this.$route.name;
      },
       registerStatus() {
          return this.$store.state.user.registerOK;
       },
       currentUser() {

          return this.$store.state.auth.user;
       },
    },
     watch: {
       '$route': {
         handler: function(page) {

           this.router = page.name


           switch (page.name) {
             case 'dashboard':
               this.activeIndex = '1';
             break
             case 'profile':
               this.activeIndex = '2-1';
               break
             case 'security':
               this.activeIndex = '2-2';
               break
             case 'verificacoes':
               this.activeIndex = '2-3';
               break
             case 'my-bikes':
               this.activeIndex = '3-1';
               break
             case 'my-reservations':
               this.activeIndex = '4-1';
               break
              case 'my-extract':
                 this.activeIndex = '4-2';
                 break
              case 'chat':
                 this.activeIndex = '5';
                 break
             case 'comments':
               this.activeIndex = '6';
               break
             case 'cards':
               this.activeIndex = '4-3';
               break
             case 'bank-accounts':
               this.activeIndex = '3-3-3';
               break
             default:
               this.activeIndex = '1';
           }

           if (page.params.page) {
             switch (page.params.page) {
               case 'minhas-bicicletas':
                 this.activeIndex = '3-1';
                 break
               case 'pedidos':
                 this.activeIndex = '3-2';
                 break
                case 'extrato':
                   this.activeIndex = '3-3-1';
                   break
               case 'solicitar-saque':
                 this.activeIndex = '3-3-2';
                 break
               case 'dados-bancario':
                 this.activeIndex = '3-3-3';
                 break
               default:
                 this.activeIndex = '1';
             }
           }

         },
         deep: true,
         immediate: true
       }
     }
 };
</script>
